import { IconButton, InputAdornment } from '@material-ui/core';
import { VisibilityOffOutlined, VisibilityOutlined } from '@material-ui/icons';
import React, { useState } from 'react';

import TextField from '../TextField';
import { useStyles } from './styles';

const PasswordField = ({ name, InputProps, ...rest }: any) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const styles = useStyles();

  return (
    <>
      <TextField
        {...rest}
        name={name}
        type={showPassword ? 'text' : 'password'}
        InputProps={
          InputProps
            ? {
                ...InputProps,
                classes:
                  InputProps && InputProps?.classes
                    ? {
                        adornedEnd: styles.adornedEnd,
                        ...InputProps.classes,
                      }
                    : {
                        adornedEnd: styles.adornedEnd,
                      },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <VisibilityOffOutlined />
                      ) : (
                        <VisibilityOutlined />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : {
                classes: {
                  adornedEnd: styles.adornedEnd,
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <VisibilityOffOutlined />
                      ) : (
                        <VisibilityOutlined />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }
        }
      />
    </>
  );
};

PasswordField.displayName = 'PasswordField';

export default PasswordField;
